import { EVENTS } from '@archetype-themes/utils/events';

class VariantSku extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    document.addEventListener(
      `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`,
      this.handleVariantChange.bind(this),
      { signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  handleVariantChange({ detail }) {
    const { html, sectionId, variant } = detail;

    console.log(`Variant change triggered:`, variant); // Debug log

    if (!variant) {
      this.textContent = '';
      console.log(`No variant selected, clearing SKU.`); // Debug log
      return;
    }

    const skuSource = html.querySelector(`[data-section-id="${sectionId}"] variant-sku`);

    if (skuSource) {
      this.textContent = skuSource.textContent;
      console.log(`Updated SKU: ${skuSource.textContent}`); // Debug log
    } else {
      console.log(`SKU source not found in updated HTML.`); // Debug log
    }
  }
}

customElements.define('variant-sku', VariantSku);
